import { RegisterStartupCallback } from "./startup";
import { service } from "./services";
import { UserAdded, UserChanged } from "./userlist";
import { GroupAdded, GroupChanged } from "./grouplist";
import { GroupLimitAdded, GroupLimitChanged, GroupLimitEdited } from "./grouplimitlist";
import { ServerAdded, ServerChanged } from "./serverlist";
import { BannerAdded, BannerChanged } from "./Bannerlist";
import { CampaignsAdded, CampaignsChanged } from "./PromotionalCredits";

// Keep lightweight realtime store updates without fetching every list on connect.
RegisterStartupCallback("ListRealtimeHandlers", async firstConnection => {
  if (!firstConnection) return;

  service.walletapi.registerOperation("UserChanged", "UserChanged", UserChanged);
  service.walletapi.registerOperation("UserAdded", "UserAdded", UserAdded);
  service.walletapi.registerOperation("GroupChanged", "GroupChanged", GroupChanged);
  service.walletapi.registerOperation("GroupAdded", "GroupAdded", GroupAdded);
  service.walletapi.registerOperation("GroupLimitAdded", "GroupLimitAdded", GroupLimitAdded);
  service.walletapi.registerOperation("GroupLimitEdited", "GroupLimitEdited", GroupLimitEdited);
  service.walletapi.registerOperation("GroupLimitChanged", "GroupLimitChanged", GroupLimitChanged);
  service.walletapi.registerOperation("GameServerChanged", "ServerList/ServerChanged", ServerChanged);
  service.walletapi.registerOperation("GameServerAdded", "ServerList/ServerAdded", ServerAdded);
  service.walletapi.registerOperation("BannerChanged", "BannerList/BannerChanged", BannerChanged);
  service.walletapi.registerOperation("BannerAdded", "BannerList/BannerAdded", BannerAdded);
  service.walletapi.registerOperation("CampaignsChanged", "CampaignsChanged", CampaignsChanged);
  service.walletapi.registerOperation("CampaignsAdded", "CampaignsAdded", CampaignsAdded);
});
